// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"737d3328","451":"5c104eaf","466":"2a4f5264","538":"c7d06733","702":"861b5b73","772":"2c9eb1b4","880":"fb42fbdb"}[chunkId] + ".chunk.js";
};